import { z } from 'zod';

export const BenchmarkDataAggregateDTO = z.object({
  year: z.number(),
  month: z.number().min(1).max(12),
  conversions: z.number(),
  repeat_conversions: z.number(), // subset of conversions
  value: z.number(), // revenue
  repeat_value: z.number(), // subset of revenue
});

export type BenchmarkDataAggregate = z.infer<typeof BenchmarkDataAggregateDTO>;

export interface UploadBenchmarkDataAggregate {
  business_id: number;
  data_source_id: number;
  data: BenchmarkDataAggregate[];
}
